var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPlaylistsActive(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1408_2577)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.6667 14.1348H2.33333C1.04222 14.1348 0 13.1026 0 11.8239V2.31087C0 1.03219 1.04222 0 2.33333 0H25.6667C26.9578 0 28 1.03219 28 2.31087V11.8239C28 13.1026 26.9578 14.1348 25.6667 14.1348ZM25.6667 23.3783H2.33333C1.04222 23.3783 0 24.4105 0 25.6891C0 26.9678 1.04222 28 2.33333 28H25.6667C26.9578 28 28 26.9678 28 25.6891C28 24.4105 26.9578 23.3783 25.6667 23.3783ZM25.6667 16.4457H2.33333C1.04222 16.4457 0 17.4779 0 18.7565C0 20.0352 1.04222 21.0674 2.33333 21.0674H25.6667C26.9578 21.0674 28 20.0352 28 18.7565C28 17.4779 26.9578 16.4457 25.6667 16.4457Z",
    fill: "#037A9A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1408_2577"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlaylistsActive);
export default __webpack_public_path__ + "static/media/Playlists_active.df65682766c7f726de44bd62cab2bd87.svg";
export { ForwardRef as ReactComponent };